import {ListView} from './list-view';

export class ListSettings {
  listViews: ListView[];

  constructor(v?: Partial<ListSettings>) {
    this.listViews = v?.listViews?.length > 0 ? v.listViews.map(lv => new ListView(lv)) : [];
  }
}
